import { DisabledLengthRule, LengthRules } from "capitalrx-components-2.0/lib/forms/validation/rules/length";

import { MAX_LENGTH_ERROR, MIN_LENGTH_ERROR, MIN_MAX_LENGTH_ERROR } from "./constants";


export function length(min: number | undefined, max: number | undefined): LengthRules {
  let result: LengthRules = DisabledLengthRule;

  if (min !== undefined) {
    result = {
      ...result,
      minLength: {
        value: min,
        message: max === undefined || min === max ? MIN_LENGTH_ERROR : MIN_MAX_LENGTH_ERROR,
      },
    };
  }

  if (max !== undefined) {
    result = {
      ...result,
      maxLength: {
        value: max,
        message: min === undefined || min === max ? MAX_LENGTH_ERROR : MIN_MAX_LENGTH_ERROR,
      },
    };
  }

  return result;
};
